import { Component, OnInit } from '@angular/core';
import { StripeService } from 'src/app/services/stripe.service';
import { StripeIntent } from 'src/app/models/stripe/stripe-intent';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Order } from 'src/app/models/order';
import { OrderService } from 'src/app/services/order.service';
import { Basket } from 'src/app/models/basket';
import { BasketService } from 'src/app/services/basket.service';
import { Router } from '@angular/router';
declare var Stripe;
import { environment } from '../../../environments/environment';
import { StreamService } from 'src/app/services/stream.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})

export class CheckoutComponent implements OnInit {
  private publishableKey:string;
  private intent: StripeIntent;
  private stripe;
  private cardElement: any;
  public errorMessage=null;
  public stripeForm:FormGroup;
  private order: Order;
  public basket: Basket;
  public processingPayment:boolean=false;
  public loggedIn:boolean=false;
  public orders: Order[];
  public isFree:boolean=false;
  public account;
  // TimeZone
  public currencySymbol = "£";
  public orderCurrency = "GBP";
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AustraliaTimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public HongKongTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public UAETimeZone:boolean = false;

  constructor(
    private stripeService: StripeService,
    private orderService: OrderService,
    private basketService: BasketService,
    private router: Router,
    private stream: StreamService,
    private auth: AuthenticationService,
    private timezoneService: TimeZoneService
  ) {
    if(localStorage.getItem('token')) this.loggedIn=true;

    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AustraliaTimeZone = this.timezoneService.checkAustraliaTimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.HongKongTimeZone = this.timezoneService.checkHongKongTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();

    if(!this.DefaultTimeZone || this.EUTimeZone){
      this.changeCurrency();
    }

    this.account=this.auth.getAccount();
    this.publishableKey=environment.stripePublishableKey;
    this.stripe=Stripe(this.publishableKey);
    this.stripeForm = new FormGroup({
      'name': new FormControl(null, Validators.required),
      'address_line_1': new FormControl(null, Validators.required),
      'address_line_2': new FormControl(null),
      'town': new FormControl(null, Validators.required),
      'county': new FormControl(null, Validators.required),
      'postcode': new FormControl(null, Validators.required),
    });

    basketService.basket.subscribe(basket => {
      this.basket = basket;

      this.basket.total = basketService.getTotal();
      this.basket.sub_total = basketService.getSubTotal();
      // this.basket.tax = basketService.getTax();
      // this.basket.discount_value=this.basketService.getDiscount();

      let description = '';
      this.basket.items.forEach(item => {
        description += item.item.title+' | ';

      });
      description=description.substr(0, description.length - 3);

      if (this.basket.total == 0) {
        this.isFree=true;
      } else {
        if(this.basket.items.length!=0){
          this.stripeService.createIntent(this.basket.total, description, this.orderCurrency).subscribe(res=>{
            this.intent = res;
            var elements = this.stripe.elements();
            this.cardElement = elements.create('card');
            this.cardElement.mount('#card-element');
          })
        }
      }


    });
  }

  ngOnInit() {
    if(this.loggedIn) this.getOrderHistory();
  }

  public changeCurrency(){
    if(this.USATimeZone){
      this.currencySymbol = "$";
      this.orderCurrency = "USD";
    }
    if(this.AustraliaTimeZone){
      this.currencySymbol = "AUD$";
      this.orderCurrency = "AUD";
    }
    if(this.AucklandTimeZone){
      this.currencySymbol = "NZ$";
      this.orderCurrency = "NZD";
    }
    if(this.HongKongTimeZone){
      this.currencySymbol = "HK$";
      this.orderCurrency = "HKD";
    }
    if(this.CanadaTimeZone){
      this.currencySymbol = "C$";
      this.orderCurrency = "CAD";
    }
    if(this.UAETimeZone){
      this.currencySymbol = "AED";
      this.orderCurrency = "AED";
    }
    if(this.EUTimeZone){
      this.currencySymbol = "€";
      this.orderCurrency = "EUR";
    }
  }

  public checkPrice(price)
  {
    if(!this.DefaultTimeZone) {
      return this.basketService.exchangeCalculator(price);
    }

    return price;
  }

  public getOrderHistory(){
    this.orderService.getOrders().subscribe(orders=>{
      if(orders.length){
        this.orders = orders;
        this.stripeForm.controls['name'].setValue(orders[0].name);
        this.stripeForm.controls['address_line_1'].setValue(orders[0].address_line_1);
        this.stripeForm.controls['address_line_2'].setValue(orders[0].address_line_2);
        this.stripeForm.controls['town'].setValue(orders[0].town);
        this.stripeForm.controls['county'].setValue(orders[0].county);
        this.stripeForm.controls['postcode'].setValue(orders[0].postcode);
      }
    })
  }

  completePaymentFree(event: any){
    event.stopPropagation();

    this.processingPayment = true;
    let order = new Order;
    order.intent_id = 'free';
    order.name = this.stripeForm.get('name').value;
    order.address_line_1 = this.stripeForm.get('address_line_1').value;
    order.address_line_2 = this.stripeForm.get('address_line_2').value;
    order.town = this.stripeForm.get('town').value;
    order.county = this.stripeForm.get('county').value;
    order.postcode = this.stripeForm.get('postcode').value;
    order.amount=0;
    order.basket = this.basketService.getBasket();
    order.tax = 0;
    order.sub_total = 0;
    order.amount = 0;
    order.currency = this.basketService.getCurrencyISOCode();

    this.orderService.createOrderFree(order).subscribe(order=>{
      this.errorMessage = null;
      this.processingPayment = false;
      if(order.id){
        this.orderService.sendNotification(order.id).subscribe();
        if(this.basket.discount_label) {
          this.stream.logDiscountUse(this.basket.discount_label).subscribe();
        }
        this.basketService.clear();
        this.router.navigate(['/account/orders']);
      }
    });

  }

  completePayment(event: any){

    event.stopPropagation();
    this.processingPayment = true;
    let order = new Order;
    order.intent_id = this.intent.id;
    order.name = this.stripeForm.get('name').value;
    order.address_line_1 = this.stripeForm.get('address_line_1').value;
    order.address_line_2 = this.stripeForm.get('address_line_2').value;
    order.town = this.stripeForm.get('town').value;
    order.county = this.stripeForm.get('county').value;
    order.postcode = this.stripeForm.get('postcode').value;
    order.amount=this.intent.amount;
    order.basket = this.basketService.getBasket();
    order.tax = this.basketService.getBasketTax(this.basket.tax);
    order.sub_total = this.basket.sub_total;
    order.amount = this.basket.total;
    order.currency = this.basketService.getCurrencyISOCode();

    this.orderService.createOrder(order).subscribe(order=>{
      this.errorMessage = null;
      this.stripe.handleCardPayment(
        this.intent.client_secret, this.cardElement, {
          payment_method_data: {
            billing_details: {name: order.name, email:this.account.email}
          }
        }
      ).then(function(result) {
        if (result.error) {
            this.errorMessage = result.error.message;
            this.processingPayment = false;

        } else {
          this.stripeService.validateOrder(order.id).subscribe(res=>{
            this.processingPayment = false;
            if(res.status=="Complete"){
              this.orderService.sendNotification(order.id).subscribe();
              if(this.basket.discount_label) {
                this.stream.logDiscountUse(this.basket.discount_label).subscribe();
              }
              this.basketService.clear();
              this.router.navigate(['/account/orders']);
            }
          })
        }
      }.bind(this));
    })

  }

}
